export default "__VITE_ASSET__94436566__"